// extracted by mini-css-extract-plugin
export var planCard = "_sg-0";
export var planList = "_sg-1";